<template>
  <section class="min-h-screen w-full">
    <div class="mx-auto" :class="{ 'event-2024-03-mb' : isMobile() === 320 , 'event-2024-03-pc' : isMobile() !== 320}">
      <div v-if="isActive" class="h-[500px] flex justify-center items-center flex-col">
        <img class="mb-3" src="https://ieltsmentor.edu.vn/wp-content/uploads/2023/10/image-10.png" alt="">
        <h3 class="text-xl text-center">Hiện tại không có chương trình quay thưởng nào đang diễn ra.</h3>
      </div>
      <div v-else class="h-full">
        <div class="flex justify-end items-center mr-6 md:14 lg:mr-16 xl:mr-20">
          <div class="mt-16">
            <div class="flex items-center">
              <div class="lg:flex mr-4"  v-text="'Xin chào, '+query.name" v-if="is_login" style="color: black;">
              </div>
              <el-button @click="logout" v-if="is_login" v-text="'Đăng xuất'" class="text-black cursor-pointer border border-red-600 px-2 py-1 rounded-md"
                         type="warning">
              </el-button>
            </div>
            <el-button @click="dialogLogin = true" v-if="!is_login" v-text="'Đăng nhập'" class="mt-[-180px] xl:mt-[-340px] text-black cursor-pointer border border-emerald-600 px-2 py-1 rounded-md"
                       type="warning">
            </el-button>
          </div>
        </div>
        <div  class="grid md:grid-cols-1 md:gap-1 lg:grid-cols-2 lg:gap-4">
          <div class="relative">
            <div class="flex justify-center px-10 md:px-16 lg:px-24 xl:mt-[105px]">
              <img class="lg:w-12/12  xs:w-6/12 mt-[40px] md:mt-[0]" src="https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/spin-top.png" alt="">
            </div>
            <div class="box-wheel relative mb-48 xl:px-20 h-[378px] md:h-[468px] overflow-hidden" style="text-align: center;">
              <div class="absolute inset-0 flex justify-center 400 bg-[length:320px_370px] md:bg-[length:400px_450px]" style="background: url('https://ieltsmentor.edu.vn/wp-content/uploads/2023/10/Asset-4@3x.png') center bottom no-repeat; background-size: 400px;" >
                <div class="absolute w-16 h-16 flex items-center justify-center z-20 font-bold top-[130px] md:top-[175px] text-[#893701] uppercase italic cursor-pointer" @click="startSpin()" >Quay</div>
              </div>
              <canvas id='canvas' :width="isMobile()" :height="isMobile()"  style="margin: auto;">
                Canvas not supported, use another browser.
              </canvas>
            </div>
            <img v-if="isMobile() === 320" class="absolute left-0 bottom-0 right-0 w-full" src="https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/footer-mb-v1.png" alt="">
            <img v-else class="absolute left-0 bottom-0 w-full" src="https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/footer-web-v1.png" alt="">
          </div>
          <!--Phạm vi sử dụng Vue-->
          <div class="w-full p-5 md:p-7 md:mt-24 xl:mt-16">
            <HistoryVoucher
                @history="is_history = true"
                @myGift="is_history = false"
                :is-history="is_history"
                :is-login="is_login"
                :data-gift="dataGift"
                :data-table="dataHistory"
                :is-mobile="mobileScreen"
            />
            <NoteComponent  :is-mobile="mobileScreen" />
          </div>
        </div>
      </div>
      <el-dialog :width="isMobile() === 320 ? '300px': '768px'" :visible.sync="dialogLogin" title="Đăng nhập">
        <template #default>
          <div class="dialog-input" style="line-height: 30px;">
            <div class="inputn_phone">
              <div class="col-xxl-3 col-md-4">
                <label><b>Số điện thoại</b><span class="ml-2" style="color:red">*</span></label>
                <div class="form-group w-100">
                  <el-input class="shadow-sm" type="text" v-model="query.phone" clearable
                            placeholder="Nhập số điện thoại" @input="CheckPhone"></el-input>
                </div>
                <p v-if="query.phone === '' && checkValidate" style="color: red">Số điện thoại không được để
                  trống</p>
                <p v-if="errorPhone === false " style="color: red">Số điện thoại chưa được đăng ký quay thưởng. Vui lòng liên hệ tư vấn viên để được hỗ trợ đăng ký.</p>
              </div>
            </div>

            <div class="col-xxl-3 col-md-4">
              <label class="mb-2"><b>Họ và tên</b></label>
              <div class="form-group w-100">
                <el-input :disabled="true" class="shadow-sm" type="text" v-model="query.name" clearable placeholder="Nhập họ và tên" ></el-input>
              </div>
              <p v-if="query.name === '' && checkValidate" style="color: red">Họ và tên không được để trống</p>
            </div>
            <div class="col-xxl-3 col-md-4">
              <label for="" class="mb-2"><b>Lớp học đăng ký</b><span class="ml-2" style="color:red">*</span></label>
              <div class="form-group w-100">
                <el-select class="shadow-sm" style="width: 100%;" v-model="query.classroom" @change="checkClassSlot()"
                           placeholder="Nhập lớp học đăng ký"  filterable>
                  <el-option
                      v-for="item in listClass"
                      :key="item.id"
                      :label="`${item?.name} `"
                      :value="item.id"
                      :disabled="item.is_of_slot"
                  >
                  </el-option>
                </el-select>
              </div>
              <p v-if="query.classroom === '' && checkValidate" style="color: red">Lớp học đăng ký không được để trống</p>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="dialog-footer text-center">
            <el-button @click="login">Đăng nhập</el-button>
          </div>
        </template>
      </el-dialog>
      <el-dialog :width="isMobile() === 320 ? '300px': '768px'" class="rounded-md" :visible.sync="centerDialogVisible"  center>
        <h3 class=" text-black text-center text-2xl pt-4 mb-6 break-normal">Chúc mừng bạn đã nhận được </h3>
        <div class="flex flex-col mb-5 justify-center items-center">
          <img class="w-1/3 mb-6" src="https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/voucher.png" alt="voucher-img">
          <h3 class="text-lg text-black " v-text="listGift[index]?.name"></h3>
        </div>
        <template #footer>
                  <span class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">Đóng</el-button>
                  </span>
        </template>
      </el-dialog>

    </div>
  </section>
</template>
<style>
.elementor-element {
  padding: 0 !important;
}
div[data-elementor-type="wp-page"] .elementor-element>.e-con-inner {
  max-width: unset;
}
.el-notification.right {
  z-index: 999999 !important;
}
.el-dialog  {
  border-radius: 12px !important;
}
.el-notification .el-notification__title {
  font-size: 16px !important;
}
.event-2024-03-pc {
  min-height: 100vh;
  display: block;
  background: url('https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/bg-web-v1.png') no-repeat;
  background-size: cover;
}
.event-2024-03-mb {
  min-height: 100%;
  background: url('https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/bg-mb-v1.png');
  background-size: cover;
}
body table td, table th {
  padding: unset !important;
  border: unset;
}
tr th {
  border: unset !important;
}
</style>
<script>

import moment from 'moment';
import * as Winwheel from "@/assets/js/Winwheel";
import NoteComponent from "@/pages/version1/components/NoteComponent.vue";
import HistoryVoucher from "@/pages/version1/components/HistoryVoucher.vue";
let URL_API_EDUTALK = 'https://api2.edutalk.edu.vn';
let GET_GIFT = 'v2/spin/customer-history/spin';
let GET_GIFT_LIST = 'v2/spin/get-gifts';
let GET_TURNS = 'v2/spin/check-turns';
let CHECK_PHONE_USER = 'v2/spin/check-user';
let GET_LIST_CLASS = 'v2/spin/get-class';
let GET_MY_GIFT = 'v2/spin/customer-history/get-spin-history-by-phone';
let GET_HISTORY_GIFT = 'v2/spin/customer-history';
let INFORMATION_SPIN = 'v2/spin/get-time-reward-program'
let GET_NAME_USER = 'v2/spin/customers/get-customer-by-phone'
export default {
  name: 'VongQuay',
  components: {NoteComponent, HistoryVoucher},
  data() {
    return {
      dataHistory:
          [],
      dataGift: [],
      is_history: true,
      is_login: false,
      centerDialogVisible: false,
      theWheel: null,
      wheelPower: 0,
      wheelSpinning: false,
      audio: null,
      left_turns: 1,
      image_url: '',
      dialogLogin: false,
      query: {
        phone: '',
        name: '',
        classname: '',
      },
      timeOut: null,
      listClass: [],
      errorPhone: null,
      checkValidate: false,
      listGift : [],
      index : -1,
      name : '',
      startDate : '',
      endDate : '',
      idProgram : null,
      checkDisable : false,
      isActive: false,
      baseUrlImage: 'https://ieltsmentor.edu.vn/wp-content/uploads/2024/06/',
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    mobileScreen() {
      if (window.innerWidth <= 1024) {
        document.body.classList.add('mobile')
        return true;
      }
    }
  },
  async mounted() {
    let phone = localStorage.phone ?? '';
    let class_id = localStorage.classroom ?? '';
    let name = localStorage.name ??''
    this.name = name
    if (phone !== '') {
      this.is_login = true
    }
    const response = await fetch(`${URL_API_EDUTALK}/${GET_GIFT_LIST}?class_id=${class_id}`);
    const gift_list = await response.json();
    if (gift_list.data != null) {
      this.isActive = true;
      let data_gift = gift_list?.data?.data ?? [];
      this.listGift = data_gift;
      let result = data_gift.map((value, key) => {
        return {'fillStyle': key % 2 ? "#0446C2" : "#fff", 'text': value.name, 'textFillStyle': key % 2 ? '#ffffff' : '#000'}
      })
      let length = data_gift.length;
      const res_turns = await fetch(`${URL_API_EDUTALK}/${GET_TURNS}?phone=${phone}&class_id=${class_id}`);
      const turns = await res_turns.json();
      let data_turns = turns.data;
      this.left_turns = this.left_turns - data_turns;
      const res_list_class = await fetch(`${URL_API_EDUTALK}/${GET_LIST_CLASS}`);
      const data_list_class = await res_list_class.json();
      this.listClass = data_list_class.data
      const res_time_program = await fetch(`${URL_API_EDUTALK}/${INFORMATION_SPIN}?class_id=${class_id}`);
      const data_time_program = await res_time_program.json();
      this.idProgram = data_time_program.data.id
      this.startDate = moment(data_time_program?.data?.start_date).format('DD/MM/YYYY')
      this.endDate = moment(data_time_program?.data?.end_date).format('DD/MM/YYYY')
      const response_name = await fetch(`${URL_API_EDUTALK}/${GET_NAME_USER}?phone=${phone}`);
      let data_name = await response_name.json()
      this.query.name = data_name.data.name
      this.audio = new Audio('https://ieltsmentor.edu.vn/wp-content/uploads/2023/10/tick.mp3');
      let width = 145;
      let textMargin = 25;
      let textFontSize = 12;
      if(/Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        width = 145;
        textMargin = 10;
        textFontSize = 10;
      }
      if (window.innerWidth >= 768) {
        width = 175;
        textMargin = 25;
        textFontSize = 12;
      }

      this.theWheel = new Winwheel.Winwheel({
        'outerRadius': width,        // Set outer radius so wheel fits inside the background.
        'innerRadius': 10,         // Make wheel hollow so segments don't go all way to center.
        'textFontSize': textFontSize,         // Set default font size for the segments.
        'lineWidth'   : 0.1,
        'textAlignment' : 'center',
        'textMargin' : textMargin,
        'numSegments': length,         // Specify number of segments.
        'segments': result,
        'animation':           // Specify the animation to use.
            {
              'type': 'spinToStop',
              'duration': 10,
              'spins': 3,
              'callbackFinished': this.alertPrize,  // Function to call whent the spinning has stopped.
              'callbackSound': this.playSound,   // Called when the tick sound is to be played.
              'soundTrigger': 'pin'        // Specify pins are to trigger the sound.
            },

      });
    }
    await this.getHistoryGift()
    await this.getMyGift()
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (window.innerWidth >= 768) {
          return 400
        }
        return 320
      } else {
        return 400
      }
    },
    login() {
      if (this.query.phone === '' || this.query.classroom === '' || !this.errorPhone) {
        this.checkValidate = true
        return
      }
      localStorage.setItem('name', this.query.name)
      localStorage.setItem('phone', this.query.phone)
      localStorage.setItem('classroom', this.query.classroom)
      location.reload();
    },
    history() {
      this.is_history = !this.is_history
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
    myGif() {
      this.is_history = !this.is_history
    },
    async getGift() {
      const response = await fetch(`${URL_API_EDUTALK}/${GET_GIFT}`);
      const gift = await response.json();
    },

    async startSpin() {
      if (this.is_login ) {
        if(this.checkDisable){
          return
        }
        this.checkDisable = true
        let phone = localStorage.phone ?? '';
        let class_id = localStorage.classroom ?? '';
        // Ensure that spinning can't be clicked again while already running.
        if (this.wheelSpinning === false) {
          // Based on the power level selected adjust the number of spins for the wheel, the more times is has
          // to rotate with the duration of the animation the quicker the wheel spins.
          this.resetWheel();
          this.image_url = ''
          this.theWheel.animation.spins = 10;

          // Disable the spin button so can't click again while wheel is spinning.
          // Important thing is to set the stopAngle of the animation before stating the spin.
          let form = new FormData();
          form.append('phone', phone);
          form.append('spin_reward_program_classroom_id', class_id);
          form.append('spin_reward_program_id',this.idProgram);
          const response = await fetch(`${URL_API_EDUTALK}/${GET_GIFT}`, {
            method: "POST",
            body: form,
          })
          const gift = await response.json();
          let id = gift?.data?.gift_id ?? -1
          let index = this.listGift.findIndex((gift)=>gift.id === id)
          this.index = index
          this.image_url = gift?.data?.url ?? ''
          this.checkDisable = false
          if (!gift.error) {
            this.theWheel.animation.stopAngle = this.theWheel.getRandomForSegment(index+1);
            // Begin the spin animation by calling startAnimation on the wheel object.
            this.theWheel.startAnimation();
            // Set to true so that power can't be changed and spin button re-enabled during
            // the current animation. The user will have to reset before spinning again.
            this.wheelSpinning = true;
          }else {
            this.$notify({
              title: 'Cảnh báo',
              message: gift.message,
              type: 'warning',
              offset: 100
            });
          }

        }
      } else {
        this.dialogLogin = true;
      }
    },
    resetWheel() {
      this.theWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
      this.theWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw();                // Call draw to render changes to the wheel.
      this.wheelSpinning = false;          // Reset to false to power buttons and spin can be clicked again.
    },
    async alertPrize(indicatedSegment) {
      //Trả kết quả
      this.wheelSpinning = false;
      this.centerDialogVisible = true;
      await this.getMyGift()
      await this.getHistoryGift()
    },
    playSound() {
      // Stop and rewind the sound if it already happens to be playing.
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.play();
    },
    async CheckPhone() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(async () => {
        const response = await fetch(`${URL_API_EDUTALK}/${CHECK_PHONE_USER}?phone=${this.query.phone}`);
        let data = await response.json();
        this.errorPhone = data.data != null
        if(this.errorPhone){
          const response = await fetch(`${URL_API_EDUTALK}/${GET_NAME_USER}?phone=${this.query.phone}`);
          let data_name = await response.json()
          this.query.name = data_name.data.name
        } else {
          this.$notify({
            title: 'Cảnh báo',
            message: 'Số điện thoại chưa được đăng ký để tham gia chương trình quay thưởng',
            type: 'warning',
            offset: 100
          });
        }
      }, 800);

    },
    async getHistoryGift() {
      const response = await fetch(`${URL_API_EDUTALK}/${GET_HISTORY_GIFT}`);
      let data = await response.json();
      this.dataHistory = data?.data?.data?.map((informationGift) => {
        return {
          id: informationGift?.id,
          name: informationGift?.name,
          phone: '*******'+informationGift?.phone.slice(7,10),
          gif: informationGift?.spin_gift?.name,
          time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY')

        }
      })
    },
    async getMyGift() {
      const response = await fetch(`${URL_API_EDUTALK}/${GET_MY_GIFT}?phone=${localStorage.getItem('phone')}`);
      let data = await response.json();
      this.dataGift = data?.data?.data?.map((informationGift) => {
        return {
          id: informationGift.id,
          classroom: informationGift?.classroom?.name,
          gift: informationGift?.spin_gift?.name,
          time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY')

        }
      })
    },
    checkClassSlot(){
      let nowClass = this.listClass.find((classroom)=>classroom.id === this.query.classroom)
      if(nowClass?.is_of_slot){
        this.query.classroom = ''
      }
    }
  }
}
</script>
